module.exports = __webpack_public_path__ + "img/1-1.7d2351d7.jpg";